import { render } from "./InputUrlForm.vue?vue&type=template&id=3c942b45&ts=true"
import script from "./InputUrlForm.vue?vue&type=script&lang=ts"
export * from "./InputUrlForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__